<template>
  <div class="footer">
    <a href="https://www.ingenieur-imac.fr/">Retour au site ingénieur IMAC</a>
  </div>
</template>
<script>
export default {
  name: 'footer',
}
</script>
<style>
  @font-face {
    font-family: 'Poppins-Regular';
    src: url('../assets/fonts/Poppins-Regular.ttf');
  }

  .footer{
    height: 50px;
    width: 100%;
    padding-top: 15px;
    background-color: #ccc;
    font-family: 'Poppins-Regular';
    text-align: center;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?18ec6c2a